<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'ショップ'"
      :sub_title="'〜 Shop Information 〜'"
      :color="'#3b3b3b'"
      :align="'center'"
    ></main-title>
    <shop-menu></shop-menu>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import ShopMenu from "@/components/organsms/shop/ShopMenu.vue";

export default Vue.extend({
  name: "ShopView",

  components: {
    MainTitle,
    ShopMenu
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #f8f2dd;
    min-height: 100vh;
    section {
      margin-top: 50px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #f8f2dd;
    min-height: 100vh;
    section {
      padding: 80px 0px;
    }
  }
}
</style>
